<!-- <div class="container mx-auto">
  <section class="pb-5">
    <div class="banner">
      <div class="relative mt-3">
          <div class="video-wrapper">
            <iframe class="w-full " width="560" height="315" src="https://www.youtube.com/embed/DNbWAopZ4ns?si=8YHeMoSfX1KI5UjK"
              frameborder="0" allowfullscreen></iframe>
          </div>
      </div>
    </div>
  </section>
</div> -->
<div class="px-2">
  <div class="container mx-auto">
    <div class="flex flex-row justify-between pt-14">
      <div class="w-full age-wrap flex flex-row flex-wrap">
        <div class="w-full lg:w-1/2 justify-end mb-12 flex px-8">
          <!-- <img class="h-auto max-h-full" src="assets/images/transcend24/transcend-banner.png"> -->
                    <iframe class="w-full " width="560" height="600" src="https://www.youtube.com/embed/DNbWAopZ4ns?si=8YHeMoSfX1KI5UjK"
                      frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="w-full lg:w-1/2 p-4">
          <h2 class="text-4xl hidden font-semibold border-[#87c042] border-5 border-l-4 border-solid pl-4 mb-4 text-gray-500 uppercase"><span class="text-[#212457]">Transcend</span> India 2024</h2>
          <h3 class="text-2xl font-semibold  mb-2" [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-700 '">
            Celebration of 11th Anniversary of NASSCOM <span class="text-[#87c042]">FAYA</span>:80
          </h3>
          <h4 class="text-xl font-semibold  mb-2" [ngClass]="currentTheme === 'dark' ? 'text-gray-400' : 'text-gray-700'">
            in Collaboration with Google for Developers
          </h4>
          <span class="text-lg font-normal italic " [ngClass]="currentTheme === 'dark' ? 'text-gray-400' : 'text-gray-500'">
            Travancore Hall, Park Centre, Technopark Phase 1
          </span>
          <span class="text-lg font-normal block italic  mb-6" [ngClass]="currentTheme === 'dark' ? 'text-gray-400' : 'text-gray-500'">
            2.30 PM, Wednesday, 5th June 2024
          </span>
          <p class=" text-lg mt-4">We celebrated the 11th Anniversary of NASSCOM FAYA:80 with a half-day AI symposium, "TRANSCEND INDIA 2024." This event, held in association with Google for Developers, KSUM, GTECH and SingulartyU Trivandrum Chapter, is designed to guide startups, IT companies, universities, and government entities on how to navigate and thrive amidst the disruptive technological changes occurring globally.
          </p>
          <p class=" text-lg mt-2 hidden">
            The program features a series of insightful keynote sessions and panel discussions, covering topics such as the latest advancements in AI technology, India's strategic response to AI disruptions, and the integration of AI in Kerala’s government and educational systems. Highlights include speakers from Google for Developers, Beckn, Mozilla Foundation, KSUM, Digital University of Kerala and successful Kerala-based startups.
          </p>
          <p class=" text-lg mt-2">Don't miss this opportunity to gain valuable insights, network with industry experts, and explore practical strategies for leveraging AI to drive innovation and growth.</p>
          <div class="register-form mt-6 mx-auto  max-md:bottom-0 max-md:fixed  max-md:w-full max-md:left-0 z-10 md:mb-4 md:px-6 px-4 max-md:py-4" [ngClass]="currentTheme === 'dark' ? 'max-md:bg-gray-800' : 'max-md:bg-white'">
            <a href="https://www.youtube.com/watch?v=DNbWAopZ4ns" target="_blank"
              class="btn btn-primary w-full text-white mb-2">Watch Now</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 " [ngClass]="currentTheme === 'dark' ? 'bg-[#232933]' : 'bg-slate-200'">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold  text-3xl pb-4 border-b" [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-600'">SPEAKERS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100" *ngFor="let speaker of speakerInfo" (click)="showModal(speaker)">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
            [src]="speaker?.thumbs" alt="{{ speaker.name }}" (error)="onProfilePicError($event)" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">{{ speaker?.name}}</h2>
              <p class="text-neutral-400">{{speaker?.job_title}}</p>
            </div>
            <p>{{ speaker?.description.length > 100 ? (speaker?.description | slice: 0:100) + '...' :
              speaker?.description }}</p>
            <div class="card-actions justify-start">
              <span (click)="showModal(speaker);$event.stopPropagation();" class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 g-slate-100 hidden">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">PANELLISTS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12" [ngClass]="currentTheme === 'dark' ? 'bg-[#242b36]' : 'bg-slate-50'">
  <div class="container mx-auto">
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-3xl pb-4 border-b" [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-600'">Travancore Hall (Park
          Center)</span></h2>
      <div class="flex flex-wrap ">
        <div class="w-full lg:w-1/4 mb-4">
          <img src="assets/images/dk17/travancore-hall.png">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">Check-in Opens</div>
            </li>

            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:30 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Welcome Note </p>
                <p class="font-semibold">Sujith Unni, Regional Head, NASSCOM</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:35 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Tech Bytes</p>
                <p class="font-semibold">Mishal Abdullah, Kerala Lead, Beckn Open Collective</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:45 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Keynote</p>
                <p>Pushing the Boundaries: The Next Era of Global AI Developments</p>
                <p class="font-bold">Anubhav Singh, Google Developer Expert </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">3:15 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Keynote</p>
                <p>Convergence of Tech: Spatial Computing, Geospatial, AR, VR, and AI</p>
                <p class="font-bold"> Nikhil Chandran, Founder and CEO of Tiltlabs</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">3:35 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Keynote</p>
                <p>Intersection of AI and Open Networks: Opportunity for India</p>
                <p class="font-bold"> Ravi Prakash, Head of Architecture and Technology Ecosystem at FIDE</p>
              </div>
            </li>


            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">4:00 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>AI for Effective Governance: Opportunities and Strategies</p>
                <p class="font-bold">Prasanth Nair IAS, Spl Secretary, Agriculture, Govt of Kerala
                </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">4:20 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>AI-Powered Multilingual Solutions: Breaking Language Barriers in India</p>
                <p class="font-bold">Joy Sebastian, Co-Founder & CEO, Techgentsia</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">4:40 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Future of SaaS: Emerging Trends and Opportunities for India</p>
                <p class="font-bold">Jofin Joseph, Partner, Pienza VC, Seattle </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">4:50 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Education in an AI-Driven World: Unlocking Opportunities</p>
                <p class="font-bold">Rahul Ramesh, Chief Technology Officer at Entri </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">5:00 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Tea Break</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">5:15 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Scaling Global: Shipping Products from Kerala to the World</p>
                <p class="font-bold">Jijo Sunny, Co-Founder & CEO of Buy Me a Coffee </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">5:30 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Innovation at Every Age</p>
                <p class="font-bold">Govind SB and Ekalevyan S, Top 100 Coders </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">5:40 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Panel Discussion</p>
                <p >Transcending Change: Essential Skills for the AI Era </p>
                <p class="font-bold mt-2">Dr Saji Gopinath, Vice Chancellor, Digital University of Kerala</p>
                <p class="font-bold mt-2">Anoop Ambika, CEO, Kerala Startup Mission</p>
                <p class="font-bold mt-2">Jibu Elias, Mozilla Responsible Computing Fellow, Co-creator of INDIAai</p>
                <p class="font-bold mt-2">Anubhav Singh, Google Developer Expert</p>
                <p class="font-bold mt-2">Dr Jayasankar Prasad, Director, DCSMAT <span class="font-normal block">(Moderator) </span></p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">6:10 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Panel Discussion</p>
                <p >CoPilot for Health Care: An AI revolution from Kerala
                </p>
                <p class="font-bold mt-2">Dr Athul Manuel,  Medical Officer, District Palliative Care Centre, Ernakulam.</p>
                <p class="font-bold mt-2">Sanjay Vijayakumar,  Co-Founder of Pupilfirst</p>
                <p class="font-bold mt-2">Bodhish Thomas, Co-Founder, Open Healthcare Network</p>
                <p class="font-bold mt-2">Niyas Mohamed, CEO & Co-Founder,NeuralCraft <span class="font-normal block">(Moderator) </span></p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">6:40 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p >Keynote</p>
                <p >Building Ethical AI Ecosystems: Challenges and Opportunities
                </p>

                <p class="font-bold mt-2">Jibu Elias, Mozilla Responsible Computing Fellow <span class="font-normal block">(Country Lead for India)</span></p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">6:55 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p >Closing Remarks</p>
                <p class="font-bold">Deepu S Nath, Managing Director, FAYA Corporation
                </p>

              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">7:00 PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p >Networking Dinner</p>
                <p >Opportunity for participants to network and discuss potential collaborations

                </p>

              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 hidden ">
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="flex w-full md:w-1/2 flex-col items-center">
        <h2 class="pb-4 border-b mb-4 md:mb-9 "> <span class="font-bold text-gray-600 text-3xl flex">PARTNERS </span>
        </h2>
        <div class="flex items-center justify-center gap-6">
          <div><img src="assets/images/dk17/sponsers-icfoss.png"></div>
          <div><img src="assets/images/dk17/sponsers-startup-mission.png"></div>
        </div>

      </div>
      <div class="flex w-full md:w-1/2 flex-col items-center">
        <h2 class="pb-4 border-b mb-4 md:mb-9 "> <span class="font-bold text-gray-600 text-3xl flex">Sponsors </span>
        </h2>
        <div class="flex items-center justify-center gap-6">
          <div class="text-center flex items-center flex-col">
            <img src="assets/images/dk17/xoxo.jpg">
            <p>Rewards & Recognition Partner</p>
          </div>
          <div class="text-center flex items-center flex-col">
            <img src="assets/images/dk17/sponsers-apollo-dimora.jpg">
            <p>Hospitality Partner </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<dialog class="modal" #speakerModal>
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button (click)="speakerModal.close()"
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left px-4 md:pr-8 pb-3 dk-image"><img class="w-full" [src]="selectedSpeaker?.thumbs" (error)="onProfilePicError($event)" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">{{ selectedSpeaker?.name }}</h2>
        <p class="text-neutral-400">{{ selectedSpeaker?.job_title }}</p>
        <p class="text-gray-500 text-sm leading-6 mt-4">{{selectedSpeaker?.description}}
        </p>
      </div>
    </div>
  </div>
</dialog>

